module.exports = __webpack_public_path__ + "static/media/tickIcon.67c0e239.svg";